// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__5L_5C","productName":"Table_productName__1FgHf"};